import { render, staticRenderFns } from "./Edit-User-Groups.vue?vue&type=template&id=3bcc467a&scoped=true&"
import script from "./Edit-User-Groups.vue?vue&type=script&lang=js&"
export * from "./Edit-User-Groups.vue?vue&type=script&lang=js&"
import style0 from "./Edit-User-Groups.vue?vue&type=style&index=0&id=3bcc467a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcc467a",
  null
  
)

export default component.exports